import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=74bba002&scoped=true&"
import script from "./imgDialog.vue?vue&type=script&lang=js&"
export * from "./imgDialog.vue?vue&type=script&lang=js&"
import style0 from "./imgDialog.vue?vue&type=style&index=0&id=74bba002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bba002",
  null
  
)

export default component.exports